import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, CheckCircle2 } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/9dXdeKBsDjyG8PNsfR5963/ChatGPT-Image-28-jun-2026_-08_31_56-p.m..webp';
export function Hero() {
  return <section className="pt-10 pb-8 px-4 sm:px-6 bg-brand-paper text-center border-b-4 border-brand-gold" data-id="element-96">
      <div className="relative z-10" data-id="element-97">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-navy/10 border border-brand-navy/30 text-brand-navy font-bold text-xs sm:text-sm mb-6 shadow-sm" data-id="element-98">
          <CheckCircle2 className="w-4 h-4 text-brand-gold" data-id="element-99" />
          <span className="tracking-wide uppercase" data-id="element-100">
            COMPLETE 6-IN-1 CLINICAL SYSTEM™
          </span>
        </div>

        <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-heading text-brand-navy mb-5 uppercase text-[20px] font-[900]" data-id="element-101">
          The Complete Professional Resource System{' '}
          <br className="hidden sm:block" data-id="element-102" />
          <span className="text-brand-gold" data-id="element-103">
            for Psychologists & Therapists
          </span>
        </h1>

        <p className="sm:text-lg text-brand-ink/80 font-medium mb-8 max-w-2xl mx-auto text-[14px]" data-id="element-104">
          Save hours of session planning, deliver superior clinical care, and
          work with absolute confidence—without creating assessments, treatment
          plans, documentation, and patient resources from scratch.
        </p>

        <a href="#pricing" className="block cursor-pointer mb-8" data-id="element-105">
          <img src={PRODUCT_IMG} alt="Psychologist Pro 6-in-1 Box Set" className="w-full max-w-2xl mx-auto object-contain drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-106" />
        </a>

        <div className="mb-6 max-w-md mx-auto" data-id="element-107">
          <CTAButton data-id="element-108">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-8 text-xs sm:text-sm text-brand-navy font-bold" data-id="element-109">
          <div className="flex items-center gap-1.5" data-id="element-110">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-111" />
            <span data-id="element-112">4.9/5 — Verified Professional Reviews</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-113">
            <Shield className="w-4 h-4 text-brand-sage" data-id="element-114" />
            <span data-id="element-115">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}